module.exports = __webpack_public_path__ + "img/icon_shift_on.4f786828.svg";